var map = {
	"./00_post_trade_order.json": "YI4R",
	"./01_get_commissionRate.json": "n+yS",
	"./02_get_leverage.json": "bFqw",
	"./03_post_leverage.json": "N7P3",
	"./04_post_allOpenOrders.json": "0Lu1",
	"./05_post_closeAllPositions.json": "vDcD",
	"./06_get_positions.json": "+oba",
	"./07_get_balance.json": "ptJe",
	"./08_get_forceOrders.json": "D/10",
	"./09_get_allFillOrders.json": "f4x/",
	"./10_delete_trade_order.json": "01Ul",
	"./11_get_all_openOrders.json": "TzVG",
	"./12_get_trade_order.json": "c76v",
	"./14_get_trade_allOrders.json": "I2ee",
	"./15_get_margin_type.json": "qPGu",
	"./16_post_margin_type.json": "LawJ",
	"./17_post_trade_positionMargin.json": "eN7O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jmrT";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/trade \.json$
// module id = jmrT
// module chunks = 3